export default __webpack_public_path__ + "static/bravemark-community-321a86986af623099464a9a132561038.png";